import ControlshermFooter from "./Controlscherm/Partials/Footer";

export const getActiveTabFooter = (userTabs, activeTab) => {
	switch (activeTab) {
		case userTabs.Controlscherm:
			return <ControlshermFooter />;

		default:
			break;
	}
};


